import { t } from "i18next";
import { useAppDispatch } from "../../redux"
import { useNavigate } from "react-router-dom";
import TableCellValue from "../common/table/TableCellValue";
import { updateEventHash, updateEventId, updateNamePharmacy, updateRangEvent } from "../../redux/reducer/LoginReducer";

const Row = (props: any) => {
  let prenotation = ((props.prenotation && props.prenotation.length) ? props.prenotation : []);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const gotoPharma = (id: string, name: string, eventHash: string, begins: string, ends: string) => {
    dispatch(updateEventId(id))
    dispatch(updateEventHash(eventHash))
    dispatch(updateNamePharmacy(name))
    let rangEvent = {
      startDate: begins,
      endDate: ends
    }
    dispatch(updateRangEvent(rangEvent))
    navigate('/prenotation')
  }


  return (
    <>
      <tbody>
        {
          prenotation.map((value: any, key: number) => (
            <tr className="tablePharmacies" key={key}  >
              <TableCellValue handleClick={() => { gotoPharma(value._id, value.description, value._hash, value.begins, value.ends) }} label={value._hash} />
              <TableCellValue disabledIcon={true} handleClick={() => { gotoPharma(value._id, value.description, value._hash, value.begins, value.ends) }} label={value.description || value.name} />
            </tr>
          ))
        }
      </tbody >

    </>
  )
}

export default Row